import React, { useState, useMemo } from 'react';
import RankTrend from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/RankTrend';
import MarketCount from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/MarketCount';
import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useMobileStoreRankRegionOptions from '@intelligence/v3/_hooks/useMobileStoreRankRegionOptions';
import { STORERANK_SEGEMENT } from '@/pages/intelligence/components/Filter/FilterBase/_config';

interface IStoreRankDetailsProps extends IBaseProps {
  entityType: IGameType;
  gameId: string;
  appIds?: any;
  appIdListAll?: any[];
  isBasicLoading: boolean;
  basicInfo: object | any;
  countryList: any[];
}

const StoreRankDetails: React.FC<IStoreRankDetailsProps> = (props) => {
  const { entityType } = props;

  const [loading, setLoading] = useState(true); // 用于给segment, loading时禁用， 也可以存在model中
  const urlSearchParams = new URLSearchParams(location.search);
  const urlTopChartsName = decodeURIComponent(urlSearchParams.get('source') || '');
  const { detailFilterExtend } = useFilterExtend({});
  const segmentCur = useMemo(() => {
    if (urlTopChartsName) {
      return 'market';
    }
    return detailFilterExtend?.[STORERANK_SEGEMENT]?.value || 'rank';
  }, [urlTopChartsName, detailFilterExtend]);

  const [activeSegment, setActiveSegment] = useState(segmentCur);
  const { isLoading: filterLoading, regionOptions } = useMobileStoreRankRegionOptions();

  return (
    <div className="dbi-mobile-games-storerank dbi-mobile-games-details-store-rank">
      {activeSegment === 'rank' ? (
        <RankTrend
          {...props}
          pageId={`details-storerank—${activeSegment}`}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
          setActiveSegment={setActiveSegment}
          activeSegment={activeSegment}
          filterLoading={filterLoading}
          regionOptions={regionOptions}
        />
      ) : (
        <MarketCount
          {...props}
          pageId={`details-storerank—${activeSegment}`}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
          setActiveSegment={setActiveSegment}
          activeSegment={activeSegment}
          filterLoading={filterLoading}
          regionOptions={regionOptions}
        />
      )}
    </div>
  );
};

export default StoreRankDetails;
